export const titleHelper = (title) => {
  const newTitle = `${document.title} - ${title}`;
  document.title = newTitle;
};
